const routes = [
    {
        path: "/housing/airport/transfer-list",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'housingrequest_index'
        }
    }
];

export default routes;
